import React, { useState } from "react";
import { useGame } from "../context/GameContext";

export default function HUD() {
  const { player, updatePlayer } = useGame();
  const [editingXP, setEditingXP] = useState(false);
  const [xpInput, setXpInput] = useState(player?.xpToLevelUp ?? 5);

  if (!player) return null;

  const hpToLevelUp = player.level;
  const hpPercent = Math.min(100, (player.hp / hpToLevelUp) * 100);
  const xpPercent = Math.min(100, (player.xp / player.xpToLevelUp) * 100);

  const handleXPSave = () => {
    const val = parseInt(xpInput);
    if (!isNaN(val) && val >= 5) updatePlayer({ xpToLevelUp: val });
    setEditingXP(false);
  };

  return (
    <div className="hud">
      <div className="hud-level">
        <span className="level-badge">LVL {player.level}</span>
      </div>
      <div className="hud-bars">
        <div className="bar-row">
          <span className="bar-label">HP</span>
          <div className="bar-track hp-track">
            <div className="bar-fill hp-fill" style={{ width: `${hpPercent}%` }} />
            <span className="bar-value">{player.hp}/{hpToLevelUp}</span>
          </div>
        </div>
        <div className="bar-row">
          <span className="bar-label">XP</span>
          <div className="bar-track xp-track">
            <div className="bar-fill xp-fill" style={{ width: `${xpPercent}%` }} />
            <span className="bar-value">{player.xp}/{player.xpToLevelUp}</span>
          </div>
        </div>
      </div>
      <div className="hud-settings">
        {editingXP ? (
          <div className="xp-edit">
            <input
              type="number"
              value={xpInput}
              min="5"
              onChange={e => setXpInput(e.target.value)}
              className="xp-input"
              autoFocus
            />
            <button className="btn-sm" onClick={handleXPSave}>SAVE</button>
            <button className="btn-sm btn-cancel" onClick={() => setEditingXP(false)}>X</button>
          </div>
        ) : (
          <button className="btn-sm" onClick={() => { setXpInput(player.xpToLevelUp); setEditingXP(true); }}>
            XP TO HP: {player.xpToLevelUp}
          </button>
        )}
      </div>
    </div>
  );
}
